import { Button, Popconfirm } from "antd";
import { useTranslation } from "react-i18next";
import NotificationPopover from "./NotificationPopover";
import NotificationMobileBellIcon from "@/assets/svg/NotificationMobileBellIcon";
import GlobeIcon from "@/assets/svg/GlobeIcon";
import DollarCircleIcon from "@/assets/svg/DollarCircleIcon";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { CurrencyDropdown, LanguageDropdown } from "@/common";

const MobileNavOthersSection = ({ isLogin, isMobile, onLogoutHandler }) => {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-[#6C7072] px-5 pb-2 text-sm mt-3">
        {t("header.others")}
      </p>
      <div className="flex flex-col gap-1">
        {isLogin && (
          <button className="flex items-center justify-between px-5 py-3 hover:bg-gray-100">
            <div className="flex items-center gap-3">
              <NotificationMobileBellIcon />
              <span className="text-[#0F0F0F]">
                {t("notifications.noNotifications")}
              </span>
            </div>

            <div className="flex items-center">
              <NotificationPopover isMobile={isMobile} />
              <DownOutlined className="text-xs text-[#51526C] mx-[10px]" />
            </div>
          </button>
        )}

        <button className="flex items-center justify-between px-5 py-2 hover:bg-gray-100">
          <div className="flex items-center gap-3">
            <GlobeIcon />
            <span className="text-[#0F0F0F]">{t("header.language")}</span>
          </div>

          <div className="flex items-center gap-3">
            <LanguageDropdown className="custom-select-currency" />
          </div>
        </button>

        <button className="flex items-center justify-between px-5 py-2 hover:bg-gray-100">
          <div className="flex items-center gap-3">
            <DollarCircleIcon />
            <span className="text-[#0F0F0F]">{t("header.currency")}</span>
          </div>

          <div className="flex items-center gap-3">
            <CurrencyDropdown className="custom-select-currency" />
          </div>
        </button>
      </div>

      {isLogin && (
        <div className="flex items-center justify-between px-7 py-2 mt-20">
          <Popconfirm
            title={t("header.logoutConfirmation")}
            okText={t("common.yes")}
            cancelText={t("common.no")}
            placement="bottom"
            onConfirm={onLogoutHandler}>
            <Button
              color="danger"
              variant="outlined"
              size="large"
              block
              className="text-[#DB0000] font-bold !border-[#FFC4C4] rtl:py-7 rtl:!leading-[normal]">
              <PlusOutlined />
              {t("header.logout")}
            </Button>
          </Popconfirm>
        </div>
      )}
    </>
  );
};

export default MobileNavOthersSection;
